export class LogItem {
    msg: string;
    type: string;
    date: number;
}
